/** The story tile that has keyboard focus (the grid marks each tile `data-grid-nav-id`), or null. */
export const getFocusedTileId = (root: Document = document): string | null => {
  const active = root.activeElement;
  if (!(active instanceof HTMLElement)) return null;
  return active.closest<HTMLElement>("[data-grid-nav-id]")?.dataset.gridNavId ?? null;
};
